export default "__VITE_ASSET__54oKszIn__"